<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Account No.</th>
                    <th style="text-align:left;">Account Name</th>
                    <th style="text-align:left;">Bank</th>
                    <th style="text-align:left;">Address 1</th>
                    <th style="text-align:left;">Address 2</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">MIT Account</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;">{{ row.accountNo }}</td>
                    <td style="text-align:left;">{{ row.accountName }}</td>
                    <td style="text-align:left;">{{ row.bankName }}</td>
                    <td style="text-align:left;">{{ row.address1 }}</td>
                    <td style="text-align:left;">{{ row.address2 }}</td>
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td style="text-align:left;">{{ row.mitAccount }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.bankId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputName" class="col-sm-2 control-label">Name</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Bank Account Name" v-model="formData.name">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputAccountNo" class="col-sm-2 control-label">Account No.</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAccountNo" placeholder="Account No" v-model="formData.accountNo">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputAccountName" class="col-sm-2 control-label">Account Name</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAccountName" placeholder="Account Name" v-model="formData.accountName">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputBank" class="col-sm-2 control-label">Bank</label>
                    <div class="col-sm-10">
                      <select v-model="formData.bankId" class="form-control" :disabled="viewMode == MODE_VIEW">
                        <option v-for="(row, i) in listBank" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>                  
                  <div class="form-group">
                    <label for="inputAddress1" class="col-sm-2 control-label">Address 1</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAddress1" placeholder="Address Line 1" v-model="formData.address1">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputAddress2" class="col-sm-2 control-label">Address 2</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputAddress2" placeholder="Address Line 2" v-model="formData.address2">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputProject" class="col-sm-2 control-label">Project</label>
                    <div class="col-sm-10">
                      <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW">
                        <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>    
                  <div class="form-group">
                    <label for="inputMITAccount" class="col-sm-2 control-label">MIT Account</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputMITAccount" placeholder="" v-model="formData.mitAccount">
                    </div>
                  </div>                                                                                                        
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'BankAccount',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      listDataTemp: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        accountNo: '',
        accountName: '',
        bankId: 0,
        bankName: '',
        address1: '',
        address2: '',
        projectId: 0,
        projectName: '',
        mitAccount: ''
      },
      listBank: null,
      listProject: null
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryBankAccountByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Account', 'get', '/api/BankAccount/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .then(response => {
          this.getProject()
            .then(response => {
              this.getBank()
                .then(response => {
                  this.combineInquiry()
                })
            })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProject() {
      return api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getBank() {
      return api
        .request('Account', 'get', '/api/Bank/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listBank = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    combineInquiry() {
      var bankName, projectName
      this.listDataTemp.forEach(itemBankAccount => {
        bankName = ''
        this.listBank.some(function(itemBank, index) {
          if (itemBankAccount.bankId === itemBank.id) {
            bankName = itemBank.name
          }
        })
        projectName = ''
        this.listProject.some(function(itemProject, index) {
          if (itemBankAccount.projectId === itemProject.id) {
            projectName = itemProject.name
          }
        })
        itemBankAccount.bankName = bankName
        itemBankAccount.projectName = projectName
      })
      this.listData = this.listDataTemp
    },
    initForm() {
      this.formData.name = ''
      this.formData.accountNo = ''
      this.formData.accountName = ''
      this.formData.bankId = 0
      this.formData.bankName = ''
      this.formData.address1 = ''
      this.formData.address2 = ''
      this.formData.projectId = 0
      this.formData.projectName = ''
      this.formData.mitAccount = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.name = row.name
      this.formData.accountNo = row.accountNo
      this.formData.accountName = row.accountName
      this.formData.bankId = row.bankId
      this.formData.bankName = row.bankName
      this.formData.address1 = row.address1
      this.formData.address2 = row.address2
      this.formData.projectId = row.projectId
      this.formData.projectName = row.projectName
      this.formData.mitAccount = row.mitAccount
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.name = data.name
      this.formData.accountNo = data.accountNo
      this.formData.accountName = data.accountName
      this.formData.bankId = data.bankId
      this.formData.bankName = data.bankName
      this.formData.address1 = data.address1
      this.formData.address2 = data.address2
      this.formData.projectId = data.projectId
      this.formData.projectName = data.projectName
      this.formData.mitAccount = data.mitAccount
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        AccountNo: this.formData.accountNo,
        AccountName: this.formData.accountName,
        BankId: this.formData.bankId,
        Address1: this.formData.address1,
        Address2: this.formData.address2,
        ProjectId: this.formData.projectId,
        MITAccount: this.formData.mitAccount
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Account', 'post', '/api/BankAccount/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay(this.formData)
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Account', 'post', '/api/BankAccount/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// BankAccount.vue?2b221184